import { ComponentControlSwitch } from 'Component'
import { GlobalSystemColumn } from 'Global'
import { TypeControlSwitch } from 'Type'

const ModuleTableColumnControlSystemToggle = () => {
    const control :TypeControlSwitch = GlobalSystemColumn()
    return <ComponentControlSwitch label={'System Columns'} control={control}/>
}

export default ModuleTableColumnControlSystemToggle